import { t } from '@framework/i18n/intl/i18next.ts';
import {
  type SearchableField,
  SearchableFieldGroup,
  SearchableFieldType,
} from '@framework/ui/components/search/ISearchableField.tsx';
import {
  NotificationInquiryTypeSelectInput as InquiryTypeSelectInput,
  notificationInquiryTypeChipValue,
} from '../../../schema/inquiry-type/NotificationInquiryTypeSelectInput.tsx';
import {
  getCommonNotificationSearchFields,
  notificationDateRangeField,
} from './getCommonNotificationSearchFields.ts';

export const searchableFrontNotificationFields: SearchableField[] = [
  ...getCommonNotificationSearchFields(),
  {
    type: SearchableFieldType.Text,
    name: 'numeroIstanza',
    label: t('notifiche-campo-numero-istanza', 'Numero Istanza'),
    group: SearchableFieldGroup.Filters,
  },
  {
    type: SearchableFieldType.Custom,
    name: 'tipoDomandaId',
    label: t('notifiche-campo-tipo-domanda', 'Tipo Domanda'),
    renderValue: notificationInquiryTypeChipValue,
    input: (
      <InquiryTypeSelectInput
        name="tipoDomandaId"
        placeholder={t(
          'notifiche-campo-tipo-domanda-placeholder',
          'Tipo Domanda...',
        )}
        size="middle"
        placement="topLeft"
      />
    ),
    group: SearchableFieldGroup.Filters,
  },
  notificationDateRangeField({
    name: 'dataNotifica',
    label: t('notifiche-campo-data-notifica', 'Data Notifica'),
    fromName: 'dataNotificaDa',
    fromLabel: t('notifiche-campo-data-notifica-da', 'Da Data Notifica'),
    toName: 'dataNotificaA',
    toLabel: t('notifiche-campo-data-notifica-a', 'A Data Notifica'),
  }),
  notificationDateRangeField({
    name: 'dataPresaVisione',
    label: t('notifiche-campo-data-lettura', 'Data Lettura'),
    fromName: 'dataPresaVisioneDa',
    fromLabel: t('notifiche-campo-data-lettura-da', 'Da Data Lettura'),
    toName: 'dataPresaVisioneA',
    toLabel: t('notifiche-campo-data-lettura-a', 'A Data Lettura'),
  }),
];
